import { type ReactNode, useState } from "react";
import "./SchedulePalettePopup.scss";
import Draggable from "react-draggable";
import { Popper } from "@mui/material";
import SchedulePalette from "@/pages/human-resources/time-management/components/schedule-palette/SchedulePalette.tsx";
import useDraggableRefsAndBounds from "@/pages/human-resources/time-management/components/schedule-palette/popup/useDraggableRefsAndBounds.ts";

interface Properties {
  anchorElement: HTMLElement | null;
  open: boolean;
  onClose: () => void;
}

export default function SchedulePalettePopup(props: Properties): ReactNode {
  const [horizontal, setHorizontal] = useState(false);
  const refsAndBounds = useDraggableRefsAndBounds<HTMLDivElement>(
    props.anchorElement,
  );

  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorElement}
      placement={"left-end"}
      style={{ zIndex: 5 }}
    >
      <Draggable
        nodeRef={refsAndBounds.draggableRef}
        handle=".drag-handle"
        defaultPosition={{ x: -290, y: 0 }}
        bounds={refsAndBounds.draggableBounds}
      >
        <div
          className="tags-and-templates-popup"
          ref={refsAndBounds.contentRef}
        >
          <div className="title-bar">
            <div className="drag-handle" />
            <div className="close-button" onClick={props.onClose}></div>
          </div>
          <SchedulePalette
            horizontal={horizontal}
            onToggleHorizontal={() => {
              setHorizontal((prev) => !prev);
              refsAndBounds.updateBounds();
            }}
          />
        </div>
      </Draggable>
    </Popper>
  );
}
